export const state = {
    data: null, // Master JSON will be stored here
    currentChurch: null,
    currentGroup: null,
    currentTopicDay: null,

    // Initialize and prepare data
    init(masterData) {
        this.data = masterData;
    },

    // Quick getters to avoid re-searching the JSON
    getChurch(id) {
        return this.data.churches.find(c => c.id == id);
    },

    getGroup(id) {
        return this.data.groups.find(g => g.id == id);
    },

    getTopic(id) {
        return this.data.topics.find(t => t.id == id);
    },

    getChurchLevels(churchId) {
        return state.data.levels.filter(l => l.church_id == churchId);
    },

    getChild(id) {
        return this.data.children.find(c => c.id == id);
    },

    getGroupFromLevel(groupId) {
        for (const level of this.data.levels) {
            const group = level.groups.find(g => g.id == groupId);
            if (group) return group;
        }
        return null;
    },

    getCurrentTopicDay() {
        return this.data
        .levels.find(l => l.church_id == this.currentChurch)
        .groups.find(g => g.id == this.currentGroup)
        .topicDays.find(d => d.id == this.currentTopicDay);
    }
};